import { render, staticRenderFns } from "./groupSpec_group.vue?vue&type=template&id=5876c42a&"
import script from "./groupSpec_group.vue?vue&type=script&lang=js&"
export * from "./groupSpec_group.vue?vue&type=script&lang=js&"
import style0 from "./groupSpec_group.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports